/**
 * ISO 4217 currency code → display symbol (aligned with backend CURRENCY_SYMBOLS).
 */
export const CURRENCY_SYMBOLS = {
  USD: '$',
  CAD: 'CA$',
  MXN: 'MX$',
  BRL: 'R$',
  GBP: '£',
  EUR: '€',
  SEK: 'kr',
  PLN: 'zł',
  JPY: '¥',
  AUD: 'A$',
  SGD: 'S$',
  INR: '₹',
  AED: 'AED',
  SAR: 'SAR',
  EGP: 'E£',
  ZAR: 'R',
  TRY: '₺',
  CNY: '¥'
}

/** Amazon marketplace code (e.g. US, DE) → ISO 4217 currency code */
const MARKETPLACE_TO_CURRENCY = {
  US: 'USD',
  CA: 'CAD',
  MX: 'MXN',
  BR: 'BRL',
  UK: 'GBP',
  GB: 'GBP',
  DE: 'EUR',
  FR: 'EUR',
  ES: 'EUR',
  IT: 'EUR',
  NL: 'EUR',
  BE: 'EUR',
  IE: 'EUR',
  SE: 'SEK',
  PL: 'PLN',
  TR: 'TRY',
  IN: 'INR',
  JP: 'JPY',
  AU: 'AUD',
  SG: 'SGD',
  AE: 'AED',
  SA: 'SAR',
  EG: 'EGP',
  ZA: 'ZAR',
  CN: 'CNY'
}

/**
 * @param {string} isoCode - ISO 4217 code (e.g. 'USD', 'EUR')
 * @returns {string} Display symbol
 */
export function getCurrencySymbol (isoCode) {
  if (!isoCode) return '$'
  const c = String(isoCode).toUpperCase()
  return CURRENCY_SYMBOLS[c] || '$'
}

/**
 * Get the currency symbol for an Amazon marketplace.
 * @param {string} marketplace - Marketplace code (e.g. 'US', 'UK', 'DE')
 * @returns {string} Currency symbol
 */
export function getCurrencyForMarketplace (marketplace) {
  if (!marketplace) return '$'
  const code = String(marketplace).toUpperCase()
  const iso = MARKETPLACE_TO_CURRENCY[code]
  if (iso) return getCurrencySymbol(iso)
  return '$'
}



// WEBPACK FOOTER //
// ./src/utils/currency.js